var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlarm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 16,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#BD00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 60.3334H51.3327V65.0001H4.66602V60.3334ZM4.66602 27.6667L16.3327 34.6667L27.9994 20.6667L39.666 34.6667L51.3327 27.6667V55.6667H4.66602V27.6667Z",
    fill: "#BD00FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm2);
export default __webpack_public_path__ + "static/media/Icon_Alarm-2.a9323493b24dafb49947ec680c0575d5.svg";
export { ForwardRef as ReactComponent };